export default __webpack_public_path__ + "static/media/audio_22_avion.c891a4a8.mp3";